const setLoadingState = ({ array, value, index }) => {
  array[index] = value;
  return [...array];
};

export default setLoadingState;
